module.exports = __webpack_public_path__ + "img/header-logo.08e78809.png";